import React, { useState } from "react";
import gettext from "../../../shared/utils/gettext";
import rvoIcon from "../../../images/import_export/rvo.svg";
import importShapefileIcon from "../../../images/import_export/import_shapefile.png";
import importFMSIcon from "../../../images/import_export/import_fms.png";
import importCloudfarmIcon from "../../../images/import_export/import_cloudfarm.png";
import exportCloudfarmIcon from "../../../images/import_export/export_cloudfarm.png";
import exportPlanIcon from "../../../images/import_export/export_plan.png";
import FarmPlansExportView from "./FarmPlansExportView";
import cropr from "../../../shared/utils/cropr";
import ViewOptionCard from "./components/ViewOptionCard";

type View = "export_plan" | "overview";
interface ImportExportProps {
  userIsStaff?: boolean;
  cropFieldsCountPerPlan: [number, number][]; // planId, count
  parcelsCount: number;
}

function ImportExport(initialProps: ImportExportProps) {
  const [view, setView] = useState<View>("overview");

  return view === "overview" ? (
    <div className="col flex-container clearfix full-height">
      {cropr.permissions.isOwner && (
        <>
          <div className="row">
            <h4 className="my-4">{gettext("Import")}</h4>
          </div>
          <div className="row">
            <ViewOptionCard
              title={gettext("Import shapefile")}
              icon={importShapefileIcon}
              onClick={() => (window.location.href = "/integration/extern/?settings_page=true")}
            />
            <ViewOptionCard
              title={gettext("Import from RVO.nl (Dutch)")}
              icon={rvoIcon}
              onClick={() =>
                (window.location.href = "/integration/extern/geoboer_sp/?settings_page=true")
              }
            />
            {cropr.features.cloudfarm && (
              <ViewOptionCard
                title={gettext("Machine and sensor data")}
                icon={importCloudfarmIcon}
                onClick={() =>
                  (window.location.href = "/integration/extern/machine_data/?settings_page=true")
                }
              />
            )}
            {(initialProps.userIsStaff || cropr.features.import_fms) && (
              <ViewOptionCard
                title={gettext("Import FMS data")}
                icon={importFMSIcon}
                onClick={() =>
                  (window.location.href = "/integration/extern/fms/?settings_page=true")
                }
              />
            )}
          </div>
        </>
      )}
      <div className="row">
        <h4 className="my-4">{gettext("Export")}</h4>
      </div>
      <div className="row">
        {cropr.permissions.plan.update && (
          <ViewOptionCard
            title={gettext("Export plan")}
            icon={exportPlanIcon}
            onClick={() => setView("export_plan")}
          />
        )}
        {cropr.features.cloudfarm && cropr.permissions.isOwner && (
          <ViewOptionCard
            title={gettext("Export machine data")}
            icon={exportCloudfarmIcon}
            onClick={() =>
              (window.location.href = "/integration/extern/export_machine_data/?settings_page=true")
            }
          />
        )}
      </div>
    </div>
  ) : (
    <div>
      <button
        className="mb-3 ml-4 btn btn-outline-smoke btn-icon"
        onClick={() => setView("overview")}
      >
        <i className="far fa-long-arrow-left pl-2" />
        {gettext("Back")}
      </button>
      {view === "export_plan" && (
        <FarmPlansExportView
          cropFieldsCountPerPlan={initialProps.cropFieldsCountPerPlan}
          parcelsCount={initialProps.parcelsCount}
        />
      )}
    </div>
  );
}

const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <div className="container-fluid clearfix">
    <div className="row p-2">
      <h3 className="col mb-3">{gettext("Import/export")}</h3>
    </div>
    <div className="row p-2">
      <div className="col" id="import-export">
        {children}
      </div>
    </div>
  </div>
);

const WrappedImportExport = (props: ImportExportProps) => (
  <Wrapper>
    <ImportExport {...props} />
  </Wrapper>
);

export default WrappedImportExport;
